import React from "react";
import commonstyles from "../../styles/SettingsTable.module.css";
import eyeView from "../../assets/img/action_view.svg";
import { useHistory } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import { AxiosInstance } from "../../utilities";
import AntTableComponent from "../ReusableComponent/AntTableComponent";
import Pagination from "../ReusableComponent/Pagination";
import LoadingIndicator from "../ReusableComponent/LoadingIndicator";
import moment from "moment";
import "antd/dist/antd.css";
import { NavLink } from "react-router-dom";
import { Modal, Button, Space, notification, Menu } from "antd";
import deleteIcon from "../../assets/img/delete.svg";
import editIcon from "../../assets/img/edit.svg";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import eyeOpen from "../../assets/icons/eye_icon.svg";
import eyeClose from "../../assets/icons/eye_close.svg";
import Password from "antd/lib/input/Password";
import arrowDown from "../../assets/images/arrow_down.svg";
import BackArrow from "../../assets/icons/back_arrow.svg";

const defaultPageSize = 10;
const pageSizes = [10, 20, 50];

function AccountList() {
  const history = useHistory();
  const [regionList, setRegionList] = useState([]);
  // const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [nextPage, setNextPage] = useState(1);
  const [pagination, setpagination] = useState({});
  const [IsLoading, setIsLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const company = JSON.parse(localStorage.getItem("companydata"));
  const { confirm } = Modal;
  const [getCompany, setGetCompany] = useState([]);
  const [filterCompany, setfilterCompany] = useState("");
  const [logisticCode, setLogisticCode] = useState("");
  const [logistic, setLogistic] = useState([]);
  const [columns, setColumns] = useState([
    /* {
      visible: false,
      key: "select",
      render: (text, record, index) => (
        <input
          style={{ cursor: "pointer" }}
          type="checkbox"
          checked={record.isChecked}
          onChange={(e) => childCheckbox(e, record)}
        ></input>
      ),
    }, */
    {
      title: "Site",
      visible: false,
      key: "company",
      render: (text, record, index) => <span>{record?.company?.code ? record?.company?.code : "-"}</span>,
    },
    {
      title: "Logistic",
      visible: false,
      key: "logisticCode",
      render: (text, record, index) => (
        <span>{record?.logisticCode ? record?.logisticCode : "-"}</span>
      ),
    },
    {
      title: "User Name",
      visible: false,
      key: "name",
      render: (text, record, index) => (
        <span>{record?.username ? record?.username : "-"}</span>
      ),
    },
    {
      title: "Password",
      visible: false,
      key: "password",
      render: (text, record, index) => (
        <>
          <input
            type={visible ? "text" : "password"}
            value={record?.password ? record?.password : "-"}
            className="form_input"
          ></input>
        </>
      ),
    },
    {
      title: "Account Number",
      visible: false,
      key: "accountNo",
      render: (text, record, index) => (
        <span>{record?.accountNo ? record?.accountNo : "-"}</span>
      ),
    },
    {
      title: "API Key",
      visible: false,
      key: "apiKey",
      render: (text, record, index) => (
        <span>{record?.apiKey ? record?.apiKey : "-"}</span>
      ),
    },
    {
      title: "Description",
      visible: false,
      key: "displayName",
      render: (text, record, index) => (
        <span>{record?.displayName ? record?.displayName : "-"}</span>
      ),
    },
    {
      title: "Action",
      visible: false,
      key: "Action",
      render: (text, record, index) => (
        <>
          <NavLink to={`/settings/editAccount/${record._id}`}>
            <img
              src={editIcon}
              className={`${commonstyles.admin_table_edit_img} mr-2`}
              alt="View account detail action icon"
              title="Edit account"
              style={{ cursor: "pointer" }}
            />
          </NavLink>
          <img
            src={deleteIcon}
            className={`${commonstyles.admin_table_edit_img} cursor-pointer ml-2`}
            // onClick={() => showdelete(record)}
            onClick={() => showDeleteConfirm(record._id)}
            alt="Delete account action icon"
            title="Delete account"
          />
        </>
      ),
    },
  ]);
  useEffect(() => {
    getCompanyDetail();
    getLogistics();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    getAccountDetailList(pageSize, nextPage, "");
    localStorage.removeItem("selectedIds");
    return () => {
      localStorage.removeItem("regionList");
      localStorage.removeItem("selectedIds");
    };
  }, [filterCompany, logisticCode]);

  function getLogistics() {
    AxiosInstance(8000, "application/json")
      .get("logistics/getLogistics")
      .then((res) => {
        if (res && res.data && res.status == "200") {
          //   console.log(res.data);
          setLogistic(res.data.data);
        }
      })
      .catch((er) => {
        // console.log(er);
        return er;
      });
  }

  const passwordVisible = () => {
    if (visible === false) {
      console.log(visible, "aa");
      setVisible(true);
    } else {
      console.log(visible, "bb");
      setVisible(false);
    }
  };

  function showNotification({ type, message, description }) {
    let options = {
      message: message || "Message",
      description: description,
      duration: 5,
    };
    notification[type](options);
  }
  function getCompanyDetail() {
    AxiosInstance(8000, "application/json")
      .get(
        `companies/getCompanies/settingsSection?pageNum=1&count=20&sortField=createdAt&sortValue=DSC`
      )
      .then((res) => {
        if (res && res.data && res.status == "200") {
          //   console.log(res.data);
          setGetCompany(res.data.data);
        }
      })
      .catch((er) => {
        // console.log(er);
        const error = {
          type: "error",
          message: "Error",
          description: "Failed to get company details",
        };
        showNotification(error);
        // return er;
      });
  }
  // *** FETCH ACCOUNT LIST *** //
  function getAccountDetailList(pageSize, nextPage, filterarr, type) {
    // setIsLoading(false);
    if (!type) {
      setIsLoading(true);
    }

    const filterOptions = {
      pagesize: pageSize,
      nextpage: nextPage,
    };

    AxiosInstance(8000, "application/json")
      .get(
        `companies/getAccountDetails?pageNum=${nextPage}&count=${pageSize}&sortField=createdAt&sortValue=DSC&companyId=${filterCompany}&logisticCode=${logisticCode}`,
        filterOptions
      )
      .then((res) => {
        // console.log(filterOptions);
        if (res && res.data && res.status == "200") {
          // console.log(res.data);
          if (res?.data?.data.length > 0) {
            res?.data?.data.forEach((item, indx) => {
              item["key"] = indx + 1;
              item["isChecked"] = false;
            });
            // console.log(res?.data?.data)
            localStorage.setItem("regionList", JSON.stringify(res?.data?.data));
            setRegionList(res?.data?.data);
            setpagination(res?.data?.pagination);
          } else {
            setRegionList([]);
            setpagination({});
          }
        }
      })
      .catch((er) => {
        showNotification({
          type: "error",
          message: "Error",
          description: "Failed to get warehouse",
        });
      })
      .finally(() => {
        setIsLoading(false);
        // setIsLoading(true);
      });
  }

  function addAccount() {
    history.push(`/settings/addAccount`);
  }
  //DELETE
  function showDeleteConfirm(id) {
    confirm({
      title: "Are you sure want to delete this ?",
      icon: <ExclamationCircleOutlined />,
      // content: "Some descriptions",
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        deleteAccountDetails(id);
      },
      onCancel() {
        // console.log("Cancel");
      },
    });
  }

  function deleteAccountDetails(id) {
    setIsLoading(true);
    AxiosInstance(8000, "application/json")
      .delete(`companies/removeAccountDetail/${id}`)
      .then((res) => {
        // console.log(res);
        if (res && res?.data && res?.status == "200") {
          showNotification({
            type: "success",
            message: "Success",
            description: "Account detail deleted successfully",
          });
          setIsLoading(false);
          getAccountDetailList(pageSize, nextPage, "");
        } else {
          showNotification({
            type: "Error",
            message: "Error",
            description: "Failed to delete account detail",
          });
        }
      })
      .catch((er) => {
        return er;
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  function debounceSearch(filter) {
    // console.log(filter);
    setIsLoading(true);
    setNextPage(1);
    getAccountDetailList(pageSize, 1, filter);
  }

  function handlepaginationChanges(value, type) {
    let filter = {};
    if (type === "pageSize") {
      setPageSize(value);
      setNextPage(1);
      getAccountDetailList(value, 1, filter);
    } else if (type === "nextPage") {
      setNextPage(value);
      getAccountDetailList(pageSize, value, filter);
    }
  }

  function filterOnChange(e) {
    const { name, value } = e.target;
    console.log(value);
    setfilterCompany(value);
    // setIsLoading(true);
  }

  function handleFormInput(e) {
    let { name, value } = e.target;
    setLogisticCode(value);
  }

  return (
    <div className={commonstyles.management_contents}>
      <div className="">
        <div className="row d-flex">
          <div className="back_arrow">
            <img
              src={BackArrow}
              onClick={() => history.push("/settings/vendorAccounts")}
              alt=""
              className="cursor-pointer"
              title="back"
              width={"25px"}
              height={"21px"}
            />
            <h1 className="heading">Account Detail</h1>
          </div>
        </div>
      </div>
      <div className={commonstyles.management_header}>
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <button
          type="button"
          className="btn btn-outline-primary"
          onClick={addAccount}
        >
          Add Account Detail
        </button>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 d-flex flex-row-reverse">
          <div className={` filter_width ${commonstyles.dropdown}`}>
        <Menu className={`filter_dropdown datefilter`}>
          <div className="card">
            <div className="card_contents">
              <div className="row no-gutters">
                <div className="card_dropdown show col-md-6">
                  <select
                    name="logisticCode"
                    value={logisticCode}
                    onChange={handleFormInput}
                    className={`form-control  ${commonstyles.form_control} `}
                    style={{ cursor: "pointer" }}
                  >
                    <option value="">ALL</option>
                    {Array.isArray(logistic)
                      ? logistic.sort((a, b) => (a.code > b.code ? 1 : -1)).map((logi) => (
                          <option key={logi._id} value={logi.code}>
                            {logi.code}
                          </option>
                        ))
                      : null}
                  </select>
                  <img src={arrowDown} className="dropDownArrow" />
                </div>
              </div>
            </div>
          </div>
        </Menu>
        </div>
        <div className={` filter_width ${commonstyles.dropdown}`}>
          <Menu className={`filter_dropdown datefilter`}>
            <div className="card">
              <div className="card_contents">
                <div className="row no-gutters">
                  <div className="card_dropdown show col-md-6">
                    <select
                      name="filterCompany"
                      value={filterCompany}
                      onChange={filterOnChange}
                      className={`form-control  ${commonstyles.form_control} `}
                      style={{ cursor: "pointer" }}
                    >
                      <option value="">ALL</option>
                      {Array.isArray(getCompany)
                        ? getCompany.sort((a, b) => (a.code > b.code ? 1 : -1)).map((company) => (
                            <option key={company?.code} value={company?._id}>
                              {company?.code}
                            </option>
                          ))
                        : null}
                    </select>
                    <img src={arrowDown} className="dropDownArrow" />
                  </div>
                </div>
              </div>
            </div>
          </Menu>
        </div>
          </div>
        </div>
     
      </div>
      <div>
        <div
          className={`${commonstyles.management_contents_search} ${commonstyles.management_contents_search_sale}`}
        >
          {/* <div
          className={`${commonstyles.management_contents_search_bar} input-group`}
        >
          <input
            type="search"
            className={`${commonstyles.form_control} form-control`}
            aria-label="Search"
            placeholder="Search by State... "
            aria-describedby="search-addon"
            value={search}
            onChange={ handleInput}
          />
          <img src={Search} alt="" />
        </div> */}
        </div>
        <div className={`${commonstyles.management_table} table-responsive`}>
          {/* {!IsLoading && regionList.length > 0 && (
                    <input
                        type="checkbox"
                        className={`${commonstyles.parentCheckbox}`}
                        onChange={parentCheckbox}
                    ></input>
                )} */}
          {IsLoading === true ? (
            <div
              className="loading-spin"
              style={{
                marginLeft: "70vh",
                marginTop: "10vh",
              }}
            >
              <tr className="bg-transparent">
                <td colSpan="100%">
                  <LoadingIndicator loadingText="Fetching Account details..." />
                </td>
              </tr>
            </div>
          ) : (
            <AntTableComponent
              className="order_table"
              tableProps={{
                columns: columns,
                dataSource: regionList,
                pagination: false,
              }}
            />
          )}
        </div>
      </div>
      {!IsLoading.list && Array.isArray(regionList) && regionList.length ? (
        <Pagination
          pageSizes={pageSizes}
          pageSize={pageSize}
          nextPage={nextPage}
          data={pagination}
          handlepaginationChanges={handlepaginationChanges}
        />
      ) : null}
    </div>
  );
}

export default AccountList;
